define('services/namedLoggingService',[
    'lib/lodash4',
    'lib/knockout',
    'config',
    'services/namedLocalLogger',
    'services/namedServerLogger'
], function (_, ko, config, LocalLogger, ServerLogger) {
    'use strict';

    var logLevelSettings = ['none', 'error', 'warn', 'info', 'debug', 'trace'];

    /**
     * Given a list of functions, return a function that will delegate to
     * each function in that list, or perform a noop if the list is empty.
     * Used to build log methods for each level.
     */
    function allOrNoop(functions) {
        if (functions.length === 0) {
            return _.noop;
        } else if (functions.length === 1) {
            return functions[0];
        } else {
            return function () {
                for (var i=0; i < functions.length; i++) {
                    functions[i].apply(this, arguments);
                }
            };
        }
    }

    var loggingService = function( namespace ) {

        var self = this;

        var componentName = namespace;

        var localLogger = new LocalLogger(componentName);
        var serverLogger = new ServerLogger(componentName);

        self.localLogLevel = ko.observable(config.localLogLevel || 'none');
        self.serverLogLevel = ko.observable(config.serverLogLevel || 'error');

        ko.computed(function () {

            var settableLogLevels = _(logLevelSettings).without('none').valueOf();
            var localLogLevelIdx = settableLogLevels.indexOf(self.localLogLevel().toLowerCase());
            var serverLogLevelIdx = settableLogLevels.indexOf(self.serverLogLevel().toLowerCase());

            for (var i = 0; i < settableLogLevels.length; i++) {
                var logLevel = settableLogLevels[i];
                var logFunctions = [];

                if (i <= localLogLevelIdx) {
                    logFunctions.push(localLogger[logLevel]);
                }
                if (i <= serverLogLevelIdx) {
                    logFunctions.push(serverLogger[logLevel]);
                }

                self[logLevel] = allOrNoop(logFunctions);

            }

        });

        return self;

    };

    return loggingService;
});

